<template>
  <div class="second_layer_list">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card header-tag="header" footer-tag="footer">
            <div slot="header">
              <i className="fa fa-align-justify"></i>
              <strong class="text-uppercase">{{$t('second_layer.second_layer') }}</strong>
              <div class="pull-right mr-4">
                <button type="button" class="btn btn-success right" @click="createSecondLayer">
                  <i class="fa fa-plus"></i>&nbsp; {{$t('second_layer.new')}}
                </button>
              </div>
            </div>
            <b-col cols="12" class="text-center">
              <!-- Start of Filter session -->
              <b-row class="mb-3">
                <b-col xl="12">
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('second_layer.active')">
                      <b-form-select v-model="filter.active"
                                     v-bind:value="filter.active"
                                     :options="statuses[$session.get('lang')]"
                                     v-bind:placeholder="$t('second_layer.active')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="pull-right mr-2">
                    <b-input-group v-bind:prepend="$t('common.data_only_lunch')">
                      <b-form-select v-model="filter.only_lunch" v-bind:value="filter.only_lunch"
                                     :options="only_lunch_statuses[$session.get('lang')]"
                                     v-bind:placeholder="$t('common.data_only_lunch')">
                      </b-form-select>
                    </b-input-group>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col xl="6">
                  <div class="pull-left mr-2">
                    <b-input-group>
                      <button type="button" class="btn bg-main border-radius-4px"
                              v-on:click="publishSecondLayer" variant="success">
                        {{$t('common.publish')}}
                      </button>
                    </b-input-group>
                  </div>
                  <div class="pull-left mr-2">
                    <b-input-group>
                      <button type="button" class="btn bg-main border-radius-4px"
                              v-on:click="publishAll" variant="success">
                        {{$t('common.push_menu_and_combo_to_production')}}
                      </button>
                    </b-input-group>
                  </div>
                </b-col>
                <b-col xl="6">
                  <b-input-group>
                    <select-dropdown v-bind:options="filter.options"
                                     v-bind:selected="filter.selected"
                                     position="prepend"
                                     v-bind:all="false"
                                     v-model="filter.field"
                                     prefix="second_layer">
                    </select-dropdown>
                    <input type="text" class="form-control" v-model="filter.key"  v-on:keydown.enter="refreshData"/>
                    <div class="input-group-append">
                      <b-input-group-append>
                        <b-btn @click="refreshData()"><i class="fa fa-search"></i>
                          {{$t('common.search')}}
                        </b-btn>
                      </b-input-group-append>
                    </div>
                  </b-input-group>
                </b-col>
              </b-row>
              <!-- End of Filter session -->

              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col">{{$t('second_layer.active')}}</th>
                    <th scope="col" v-for="item in dataTable.fields" :key="item.id"
                        @click="updateSort(item.name)" :class="item.sort?'pointer':''">
                      <i class="fa fa-sort-amount-asc text-muted"
                         v-if="dataTable.sort.type === 'asc' && dataTable.sort.field === item.name"></i>
                      <i class="fa fa-sort-amount-desc text-muted"
                         v-if="dataTable.sort.type === 'desc' && dataTable.sort.field === item.name"></i>
                      <span v-if="item.label != null">{{$t('second_layer.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('second_layer.'+item.name)}}</span>
                    </th>
                    <th scope="col">{{$t('common.action')}}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTable.items.length === 0">
                    <td class="text-center" :colspan="dataTable.fields.length + 5">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTable.items" :key="item.id">
                    <td scope="row">
                      <c-switch type="icon" variant="success"
                                v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                                v-model="item.active" :value="1" :uncheckedValue="0"
                                @change="updateStatusItem(item)"/>
                    </td>
                    <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                                            <span v-if="field.render != null"
                                                  v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                                                 {{item[field.name]}}
                                            </span>
                    </td>
                    <td scope="row" width="100">
                      <b-button size="sm" variant="primary" v-on:click="editItem(item.uuid)">
                        <i class="fa fa-edit"></i> {{$t('common.edit')}}
                      </b-button>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->

              <!-- Start of paginate session -->
              <b-row>
                <b-col>
                  <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                                v-model="dataTable.currentPage"/>
                </b-col>
                <b-col class="text-left">
                  {{$t('message.datatable_total', {number: dataTable.items.length, total:
                  dataTable.total})}}
                </b-col>
                <b-col col lg="1">
                  <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100]"
                                 class="mb-3"/>
                </b-col>
              </b-row>
              <!-- Start of paginate session -->
            </b-col>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<style scoped>
  .table thead th:nth-child(1) {
    width: 100px;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #0091ff !important;
    border-radius: 3px !important;
  }

  .custom-control-label::before {
    border-radius: 3px !important;
  }
</style>
<script>
  import SelectDropdown from '../../../components/Partials/SelectDropdown'
  import axios from 'axios'
  import cSwitch from '../../../components/Switch'

  const CancelToken = axios.CancelToken
  let cancel = null
  let vm = null

  export default {
    name: 'SecondLayerList',
    components: {
      SelectDropdown,
      cSwitch,
    },
    data: function () {
      return {
        allSelected: false,
        statuses: [],
        only_lunch_statuses: [],
        filter: {
          options: [],
          active: 1,
          status: '',
          only_lunch: '',
          name: '',
          field: null,
          key: null,
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'only_lunch',
              label: 'only_lunch',
              filter: false,
              sort: true,
              render: (data) => {
                if(data === 1) {
                  return vm.$t('common.only_lunch')
                } else {
                  return vm.$t('common.non_only_lunch')
                }
              }
            },
            {
              name: 'sku',
              label: 'sku',
              filter: true,
              sort: true,
              render: (data) => {
                return data
              }
            },
            {
              name: 'name',
              label: 'second_layer_name',
              filter: true,
              sort: true,
              render: (data) => {
                if (data == null) {
                  return ''
                }
                return data[this.$session.get('lang')]
              }
            },
            {
              name: 'short_name',
              label: 'short_name',
              filter: true,
              sort: true,
              render: (data) => {
                return data
              }
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
      }
    },
    methods: {
      publishSecondLayer () {
        vm.axios.menu.publishSecondLayer(function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.ids = []
          vm.refreshData()
        })
      },
      publishAll () {
        vm.axios.menu.publishMenu({
          'scope': 'all',
          'publish_pizza': 1
        }, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        })

        vm.axios.menu.publishCombo({
          'scope': 'all',
        }, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
        })
      },

      /**
       * update sort field and sort type then refresh data
       * @param field
       */
      updateSort (field) {
        for (let i in this.dataTable.fields) {
          if (!this.dataTable.fields.hasOwnProperty(i)) continue
          if (this.dataTable.fields[i].name === field && (this.dataTable.fields[i].sort == null || this.dataTable.fields[i].sort === false)) {
            return
          }
        }
        if (this.dataTable.sort.field !== field) {
          this.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        } else {
          if (this.dataTable.sort.type === 'asc') {
            this.dataTable.sort = {
              field: field,
              type: 'desc'
            }
          } else {
            this.dataTable.sort = {
              field: field,
              type: 'asc'
            }
          }
        }

        this.refreshData()
      },
      /**
       * refresh data for data table
       */
      refreshData () {
        if (cancel != null) {
          cancel()
        }

        //get params
        let _data = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage,
          sort_field: this.dataTable.sort.field,
          sort_type: this.dataTable.sort.type
        }
        if (String(this.filter.active) !== '') {
          _data['active'] = this.filter.active
        }

        if (String(this.filter.only_lunch) !== '') {
          _data['only_lunch'] = this.filter.only_lunch
        }

        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          _data[this.filter.field] = this.filter.key.trim()
        }

        //process to send via get method
        let params = ''
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        //remove tail
        params = params.slice(0, -1)

        vm.axios.menu.getSecondLayerList(params, function (response) {
          vm.dataTable.items = response.data.data.items
          vm.dataTable.total = response.data.data.pagination.total
          this.$forceUpdate()
        })
      },
      /**
       * move to detail page by uuid
       * @param uuid
       */
      editItem (uuid) {
        this.$router.push({name: 'second_layer_edit', params: {uuid: uuid}})
      },
      /**
       * update active by uuid
       * @param item and active
       */
      updateStatusItem (item) {
        let params = {
          uuid: item.uuid,
          active: item.active
        }
        this.axios.menu.updateSecondLayerStatus(params, function (response) {
          vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
          vm.refreshData()
        })
      },
      createSecondLayer: function () {
        this.$router.push({name: 'second_layer_create', params: {uuid: 'create'}})
      },
      /**
       * get list categories for select box
       */
      getStatusData () {
        let langs = Object.keys(vm.$i18n.messages)
        for (let l in langs) {
          vm.only_lunch_statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.only_lunch', langs[l]), value: 1},
            {text: vm.$t('common.non_only_lunch', langs[l]), value: 0}
          ]
          vm.statuses[langs[l]] = [
            {text: vm.$t('common.all', langs[l]), value: ''},
            {text: vm.$t('common.active', langs[l]), value: '1'},
            {text: vm.$t('common.inactive', langs[l]), value: '0'}
          ]
        }
      }
    },
    created: function () {
      this.debouncedInput = _.debounce(this.refreshData, 240)
      vm = this
      let CancelToken = vm.axios.CancelToken
      vm.dataTable.source = CancelToken.source()

      for (let i in vm.dataTable.fields) {
        if (!vm.dataTable.fields.hasOwnProperty(i)) continue
        let field = vm.dataTable.fields[i].name
        if (vm.dataTable.fields[i].filter != null && vm.dataTable.fields[i].filter === true) {
          vm.filter.options.push(vm.dataTable.fields[i])
        }
        if (vm.dataTable.fields[i].sort != null && vm.dataTable.fields[i].sort === true && vm.dataTable.sort.field == null) {
          vm.dataTable.sort = {
            field: field,
            type: 'asc'
          }
        }
      }
      vm.$Progress.start()
      vm.getStatusData()
      let filter = this.$session.get('filter', null)
      if (filter != null && this.$route.query && this.$route.query.rollback) {
        for (let i in filter.filter) {
          if (!filter.filter.hasOwnProperty(i)) continue
          this.filter[i] = filter.filter[i]
        }
        for (let i in filter.dataTable) {
          if (!filter.dataTable.hasOwnProperty(i)) continue
          this.dataTable[i] = filter.dataTable[i]
        }
      }
      vm.refreshData()
    },
    beforeDestroy: function () {
      this.$session.set('filter', {
        filter: this.filter,
        dataTable: {
          sort: {
            field: this.dataTable.sort.field,
            type: this.dataTable.sort.type
          },
          currentPage: this.dataTable.currentPage,
          perPage: this.dataTable.perPage
        }
      })
    },
    watch: {
      'filter.key': function () {
        this.debouncedInput()
      },
      'dataTable.currentPage': function () {
        vm.refreshData()
      },
      'dataTable.perPage': function () {
        vm.refreshData()
      },
      'filter.active': function () {
        vm.refreshData()
      },
      'filter.only_lunch': function () {
        vm.refreshData()
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/second-layer/List.vue